module.exports = __webpack_public_path__ + "img/platform-B-1.872771bb.jpg";